<template>
  <div>
    <!-- Event type rows -->
    <div v-for="eventType in eventTypes" :key="eventType" 
      class="flex items-center justify-between px-1.5 hover:bg-neutral-100 rounded-lg py-1">
      <!-- Event type label -->
      <div class="text-sm font-medium text-neutral-900">
        {{ eventType }}
      </div>
      <!-- Event count -->
      <div class="text-lg font-bold text-neutral-800">
        {{ getUserEventCount(eventType) }}
      </div>
    </div>

    <!-- Total row -->
    <div class="flex items-center justify-between px-1.5 pt-2 mt-1 border-t border-neutral-300">
      <div class="text-sm font-medium text-neutral-900">
        Total
      </div>
      <div class="text-lg font-bold text-neutral-800">
        {{ getUserTotalEventCount() }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from "vue";
import { useEventsStore } from "@/stores/eventsStore";

const props = defineProps({
  user: {
    type: Object,
    required: true,
  },
  startDate: {
    type: Date,
    required: true,
  },
  endDate: {
    type: Date,
    required: true,
  },
});

const eventsStore = useEventsStore();
const eventTypes = computed(() => eventsStore.getAllEventTypes);

function getUserEventCount(eventType) {
  return props.user.events.filter(event =>
    event.type === eventType &&
    new Date(event.date) >= props.startDate &&
    new Date(event.date) <= props.endDate
  ).length;
}

function getUserTotalEventCount() {
  return eventTypes.value.reduce((total, eventType) => {
    return total + getUserEventCount(eventType);
  }, 0);
}
</script>